export enum FileKind {
  File = 'file',
  Folder = 'folder',
}
